<template>
  <div v-html="paymentIFrame"></div>
</template>

<script>
import { mapGetters } from "vuex";
import { PAY_TYPE_APPLE, SENTRY_ERRORS } from "@/../app-constants";
import errorLoggerAdapter from "@/adapters/errorLoggerAdapter";

export const MESSAGE_TYPES = {
  ERRORS: 1,
  HEIGHT_CHANGED: 2,
  PAYMENT_KEY_OBTAINED: 3,
  VALIDATIONS: 4,
  INIT_PAYMENT_DATA: 9
};

export default {
  name: "FPIframe",
  props: {
    paymentIFrame: {
      type: String,
      required: true
    },
    paymentKeyEventHandler: {
      type: Function,
      required: true
    },
    errorHandler: {
      type: Function,
      required: true
    },
    paymentType: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      initDataSet: false
    };
  },

  computed: {
    ...mapGetters({
      initAPData: "cart/getFPInitDataForAP"
    })
  },

  mounted() {
    window.addEventListener("message", this.handleMessage);
  },

  beforeUnmount() {
    window.removeEventListener("message", this.handleMessage);
  },

  methods: {
    setFrameHeight(height) {
      const element = document.getElementById("payment-iframe");
      if (element) {
        element.height = height;
        element.style.width = "100%";
      }
    },
    overrideInitAPsettings() {
      // overrides default FP settings with our own.
      if (this.initDataSet || this.paymentType !== PAY_TYPE_APPLE) return;

      try {
        this.initDataSet = true;
        FreedomPay.Apm.ApplePay.initialize(this.initAPData);
      } catch (e) {
        // do nothing
      }
    },
    handleMessage(e) {
      const { data, type } = e.data;
      switch (type) {
        case MESSAGE_TYPES.ERRORS:
          errorLoggerAdapter.createIssue(SENTRY_ERRORS.ERROR_OAPI_IFRAME_ERROR, "checkoutError", "handleMessage", {
            description: JSON.stringify(data),
            paymentType: this.paymentType
          });
          this.errorHandler(data);
          break;

        case MESSAGE_TYPES.HEIGHT_CHANGED:
          if (data.height === 0) return;
          this.setFrameHeight(data.height);
          this.overrideInitAPsettings();
          break;

        case MESSAGE_TYPES.PAYMENT_KEY_OBTAINED:
          this.paymentKeyEventHandler(data);
          break;
      }
    }
  }
};
</script>
